import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/index_first_screen_banner.png';
import _imports_1 from '@/assets/images/index_youshi_icon_1.png';
import _imports_2 from '@/assets/images/index_youshi_icon_2.png';
import _imports_3 from '@/assets/images/index_youshi_icon_3.png';
import _imports_4 from '@/assets/images/index_youshi_icon_4.png';
import _imports_5 from '@/assets/images/homeIntro2.jpg';
import _imports_6 from '@/assets/images/homeBanner.jpg';
import _imports_7 from '@/assets/images/homeBooks.jpg';
import _imports_8 from '@/assets/images/homeIntro3.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3d66d7f6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container"
};
var _hoisted_2 = {
  class: "index-first-screen"
};
var _hoisted_3 = {
  class: "middle-box max-width"
};
var _hoisted_4 = {
  class: "textArea"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "全球领先数字家谱在线编修平台", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "三步成谱：录入族员 -> 体例选版 -> 自动排版", -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("获取验证码");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("立即修谱");

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "banner"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "image"
  })], -1);
});

var _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"index-youshi\" data-v-3d66d7f6><div class=\"index-youshi-in\" data-v-3d66d7f6><div class=\"box max-width\" data-v-3d66d7f6><div class=\"title-box\" data-v-3d66d7f6><h2 class=\"title\" data-v-3d66d7f6>互联网家谱的优势</h2><p class=\"title2\" data-v-3d66d7f6> 互联网家谱是传统家谱的延伸，互联网家谱是传统家谱的升华，互联网家谱是传统家谱的新家。 <br data-v-3d66d7f6> 互联网家谱的灵活性大大降低了修家谱的门槛，对子孙后代来说具有十分重要的意义，互联网家谱让家族观念继续向文化传承和亲情延续 <br data-v-3d66d7f6></p></div><div class=\"list\" data-v-3d66d7f6><div class=\"item\" data-v-3d66d7f6><img class=\"icon\" src=\"" + _imports_1 + "\" alt=\"互联网家谱优势\" data-v-3d66d7f6><p class=\"title\" data-v-3d66d7f6>省时、省力、省钱</p><p class=\"txt\" data-v-3d66d7f6> 修订家谱费时、费力、而在互联网家谱上轻点，即可完成查谱、修谱、寻亲、沟通等一系列活动。 </p></div><div class=\"item\" data-v-3d66d7f6><img class=\"icon\" src=\"" + _imports_2 + "\" alt=\"互联网家谱优势\" data-v-3d66d7f6><p class=\"title\" data-v-3d66d7f6>准确、清晰、易查看</p><p class=\"txt\" data-v-3d66d7f6> 新谱资料可实时入谱，保证信息的准确性；随时对错误信息进行更新；还可节省大量旧谱重修与翻录的支出，减少因翻录造成的二次错误。 </p></div><div class=\"item\" data-v-3d66d7f6><img class=\"icon\" src=\"" + _imports_3 + "\" alt=\"互联网家谱优势\" data-v-3d66d7f6><p class=\"title\" data-v-3d66d7f6>安全、私密、易保存</p><p class=\"txt\" data-v-3d66d7f6> 联网家谱相对于传统家谱来说，它具有更安全、更私密、易保存的特点。网络存储，介质备份保存，不怕潮湿、不怕虫蛀等；携带也极其方便。 </p></div><div class=\"item\" data-v-3d66d7f6><img class=\"icon\" src=\"" + _imports_4 + "\" alt=\"互联网家谱优势\" data-v-3d66d7f6><p class=\"title\" data-v-3d66d7f6>便于修改、续谱</p><p class=\"txt\" data-v-3d66d7f6> 互联网家谱不受时间和地域的限制，随时上传、随时编辑、随时修改，真正实现零距离沟通。 </p></div></div></div></div></div><div class=\"title-box\" data-v-3d66d7f6><h1 data-v-3d66d7f6>PC/手机，多平台互通，实时更新</h1><h4 data-v-3d66d7f6>电脑端与手机互联互通，增修纠错随时进行</h4></div><img src=\"" + _imports_5 + "\" alt=\"\" style=\"width:100%;\" data-v-3d66d7f6><div class=\"title-box\" data-v-3d66d7f6><h1 data-v-3d66d7f6>手机移动端随处可阅</h1><h4 data-v-3d66d7f6> 家谱树状图，备份关系一目了然，了解家族成员个人信息及生平事迹； 祭祀、赶集、测试、资讯、视频、种草等多功能满足用户需求； 动态内容券，助寻家族成员更轻松。 </h4></div><div class=\"title-box\" data-v-3d66d7f6><h1 data-v-3d66d7f6>智能排版，多种家谱版式可供选择</h1><h4 data-v-3d66d7f6>实现人员录入、智能排版、导出打印三步轻松完成修家谱</h4></div><div data-v-3d66d7f6><img src=\"" + _imports_6 + "\" alt=\"\" class=\"introImage\" data-v-3d66d7f6></div><div class=\"title-box\" data-v-3d66d7f6><h1 data-v-3d66d7f6>专业家谱编印，本站可提供家谱印刷</h1><h4 data-v-3d66d7f6>让每个家族都能拥有大气典雅的家族谱</h4></div><div style=\"text-align:center;\" data-v-3d66d7f6><img style=\"width:60%;\" src=\"" + _imports_7 + "\" alt=\"\" class=\"introImage\" data-v-3d66d7f6></div>", 8);

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "",
    class: "introImage"
  })], -1);
});

import IntroFunc from './components/introFunc';
import IntroProgress from './components/introProgress';
export default {
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_col = _resolveComponent("el-col");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_row = _resolveComponent("el-row");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createVNode(_component_el_row, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _ctx.input3,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.input3 = $event;
                }),
                placeholder: "请输入电话号码",
                class: "input-with-select"
              }, {
                prepend: _withCtx(function () {
                  return [_createVNode(_component_el_select, {
                    modelValue: _ctx.select,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _ctx.select = $event;
                    }),
                    placeholder: "+86",
                    style: {
                      "width": "90px"
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_option, {
                        label: "Restaurant",
                        value: "1"
                      }), _createVNode(_component_el_option, {
                        label: "Order No.",
                        value: "2"
                      }), _createVNode(_component_el_option, {
                        label: "Tel",
                        value: "3"
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _ctx.input3,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.input3 = $event;
                }),
                placeholder: "请输入验证码"
              }, {
                append: _withCtx(function () {
                  return [_hoisted_7];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: "primary"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_8];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_checkbox, {
        modelValue: _ctx.checked1,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _ctx.checked1 = $event;
        }),
        label: "注册即表示你已同意 服务条款 和 隐私政策",
        size: "large",
        checked: ""
      }, null, 8, ["modelValue"])]), _hoisted_9])]), _createElementVNode("div", null, [_createVNode(_unref(IntroFunc))]), _hoisted_10, _createVNode(_unref(IntroProgress)), _hoisted_18]);
    };
  }
};